import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { TextSpan } from 'app/typography';
import { UPLOAD_INPUT_TYPES } from '.';

export const UploadContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 12px;
`;

export const PreviewImageContainer = styled.div`
  ${(props) =>
    props.type === UPLOAD_INPUT_TYPES.LOGO
      ? css`
          width: 60px;
          height: 60px;
          border-radius: 4px;
          background: ${props.url
            ? 'var(--color-background-white)'
            : 'var(--color-background-light)'};
          border: 1px solid var(--color-border-medium);
          & img {
            max-width: 100%;
            max-height: 100%;
          }
        `
      : css`
          width: 100px;
          min-width: 100px;
          height: 100px;
          border-radius: 50%;
          background: var(--color-background-light);
          border: 1px solid var(--color-border-dark);
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
          span {
            color: var(--color-font-placeholder);
          }
        `}

  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const placeholderCommonStyles = css`
  font-family: 'Proxima Nova', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  letter-spacing: -0.00125em;
`;

export const StyledLabelWrapper = styled.label`
  display: flex;
  flex-direction: column;
  outline: none;
`;

export const StyledLabel = styled(TextSpan)`
  color: ${(props) =>
    props.disabled
      ? 'var(--color-font-placeholder)'
      : 'var(--color-font-primary)'};
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const StyledFileInputWrapper = styled.span`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 185px;
  margin-left: ${({ showImage }) => (showImage ? 20 : 0)}px;
  border-radius: 4px;
  overflow: hidden;
  padding: 0 15px;
  min-height: 36px;
  cursor: pointer;
  color: var(--color-background-medium);

  &:hover {
    color: var(--color-button-secondary-hover);
  }
`;

export const StyledPlaceholder = styled.span`
  ${placeholderCommonStyles};

  margin: 10px 0;
  color: var(--color-button-secondary-default);
  font-weight: 600;

  & > span {
    ${placeholderCommonStyles};

    color: var(--color-font-placeholder);

    input[disabled] ~ & {
      color: var(--color-background-medium);
      cursor: default;
    }
  }

  input[disabled] ~ & {
    cursor: default;
    color: var(--color-background-medium);
  }
`;

export const StyledFile = styled.span`
  margin: 10px 0 0;
  display: flex;
  max-width: 100%;

  &:first-of-type {
    margin-top: 15px;
  }

  & > button {
    position: relative;
    width: 12px;
    height: 12px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-color: transparent;
    overflow: hidden;
    text-indent: -999em;
    outline: none;
    & > svg {
      top: 0;
      left: 0;
      position: absolute;
    }
  }

  & > p,
  > span {
    ${placeholderCommonStyles};

    color: ${({ created }) =>
      created
        ? 'var(--color-font-placeholder)'
        : 'var(--color-background-medium)'};
    padding-left: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
